<template>
<div>



<v-text-field  v-model='groups.q' placeholder="Поиск по сообществам">
<v-iconslot="append">mdi-magnify</v-icon>
</v-text-field>

<v-select @change="getByListUpdate()" color="#273C51"  label="Сортировка сообществ" v-model="groups.sort.selected"   :items="groups.sort.options"></v-select>

<div >
<v-tooltip top v-if="groups.selector === false">
<span>Выбрать все сообщества</span>
<v-btn  style="margin:0px" slot="activator" small icon @click='selectAll()'>
<v-icon>mdi-select</v-icon>
</v-btn>
</v-tooltip>
<v-tooltip top v-else>
<span>Отменить выбор</span>
<v-btn  style="margin:0px" slot="activator" small icon @click='selectAll()'>
<v-icon>mdi-select-off</v-icon>
</v-btn>
</v-tooltip>

<v-tooltip top>
<span>Копировать выбранные</span>
<v-btn  style="margin:3px" slot="activator" small icon @click='copy()'>
<v-icon>mdi-content-copy</v-icon>
</v-btn>
</v-tooltip>

<v-tooltip top max-width="250">
<span>Экспортировать выбранные сообщества в задания</span>
<v-btn  style="margin:3px" slot="activator" small icon @click='toExports()'>
<v-icon>mdi-export</v-icon>
</v-btn>
</v-tooltip>

<v-tooltip top max-width="250">
<span>Получить список новых подписчиков, для выбранных сообществ</span>
<v-btn  style="margin:3px" slot="activator" small icon @click="update()">
<v-icon color="#273C51">mdi-update</v-icon>
</v-btn>
</v-tooltip>

<v-tooltip top max-width="250">
<span>Разрешить автообновление для выбранных сообществ</span>
<v-btn  style="margin:3px" slot="activator" small icon @click="setMuteMulti(0)">
<v-icon color="green">mdi-account-plus</v-icon>
</v-btn>
</v-tooltip>

<v-tooltip top max-width="250">
<span>Запретить автообновление для выбранных сообществ</span>
<v-btn  style="margin:3px" slot="activator" small icon @click="setMuteMulti(1)">
<v-icon color="red">mdi-account-off</v-icon>
</v-btn>
</v-tooltip>

<v-tooltip top>
<span>Удалить выбранные сообщества</span>
<v-btn  style="margin:3px" slot="activator" small icon @click="deleteSelected()">
<v-icon color="red">mdi-close</v-icon>
</v-btn>
</v-tooltip>

</div>



<div  style="font-size:1.2em " >
  <div style="height:5px"></div>
  <v-divider></v-divider>
  <div v-ripple @click="changeCat()"  class="meneg_item2" > Переместить в список</div>
</div>







  <v-dialog v-model="toExport.dialog" scrollable max-width="300px">
      <v-card>
        <v-card-title> <v-icon medium left style="marginRight:5px"  >mdi-export</v-icon>   Экспорт {{this.groups.selected.length}} в задания</v-card-title>
        <v-divider></v-divider>
        <v-card-text fluid   style="height: 300px;">

          <div  v-if="toExport.loading && toExport.tasksList.length<1" class="text-xs-center">
<v-progress-circular

  :size="70"
  :width="7"
  color="#4A76A8"
  indeterminate
></v-progress-circular>
          </div>

          <div v-for=" item  in this.toExport.tasksList" >
          <v-checkbox v-model="tasks.selected"  v-bind ='[{label:item.name},{value:item.task_id}]'     ></v-checkbox>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A76A8" flat small   @click.native="toExport.dialog = false">Закрыть</v-btn>
          <v-btn v-if='tasks.selected.length>0' :loading="toExport.adding"  :disabled="toExport.adding" color="#4A76A8" small class="white--text"  @click="exportResources()">Выбрать</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>









  <v-dialog v-model="groups.modals.changeCatSelected" scrollable max-width="350px">
      <v-card>

        <v-toolbar flat >
        <v-icon>mdi-checkbox-multiple-marked</v-icon>
        <v-toolbar-title style="color:gray">    Переместить в список</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon style="cursor: pointer" color="#4A76A8" @click.native="groups.modals.changeCatSelected = false" >mdi-close</v-icon>
        </v-toolbar>

        <v-divider></v-divider>
        <v-card-text fluid   style="height: 300px;">
         <v-checkbox @click="lists.newListName = ''" v-model="lists.createNew" label="Переместить в новый список ?"></v-checkbox>
       <v-text-field v-if="lists.createNew"
       v-model="lists.newListName"
       label="Придумайте название нового списка"
       >
       </v-text-field>

       <v-select v-if="!lists.createNew"
       :items="groups.catList" v-model="lists.newListName"
       placeholder="Выберите существующий список"
       >
      <template slot="selection" >
       <span >
        {{lists.newListName}}
       </span>
     </template>

     <template v-slot:item="{ item, attrs, on }">

       <v-list v-bind="attrs">

         <span v-if="item !==groups.selectedCat"  >{{ item }}</span>
         <span style="color:gray" v-else>Текущий список</span>
       </v-list>

     </template>


       </v-select>



        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A76A8" flat small   @click.native="groups.modals.changeCatSelected = false">Закрыть</v-btn>
          <v-btn v-if='lists.newListName.length>0 ' :loading="lists.loading"  :disabled="lists.loading" color="#4A76A8" small class="white--text"  @click="changeCatList()">Переместить</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>






<v-snackbar v-model="sb.snackbar" :color="sb.color" absolute top :timeout="2000">
{{sb.text}}
<v-btn dark flat @click="sb.snackbar = false">ОК</v-btn>
</v-snackbar>

</div>
</template>
<script>
import axios from 'axios'
export default {
props:['groups'],
 data(){
   return {
     css: {
       marginTop: "10px"
     },
     lists:{
       createNew : false,
       newListName: "",
       loading : false,
       adding: false,


     },

     tasks:{
       selected:[]
     },
     sb:{
     snackbar: false,
     color: 'success',
     text: ''
   },
    toExport: {
      tasksList:[],
      dialog : false,
      loading: true,
      adding: false,

    }
   }
 },
 methods : {

setMuteMulti(mode){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/set_mute_multi.php', {
method: 'POST',
data:{
grIds: this.groups.selected,mode:mode
}
})
.then( response => {
if(response.data.rsp == 'ok'){
//console.log(this.groups.all)
this.groups.selected.forEach(function(item, i, arr){
item.is_mute = mode
})
}
})
},


getByListUpdate(){
this.groups.all = []
this.groups.loading = true
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_get_by_list.php', {
method: 'POST',
data : {catList:this.groups.catList, selectedCat:this.groups.selectedCat,sort:this.groups.sort.selected },
}).then(response => {
 this.groups.loading = false
 this.groups.displayCount = 25
 if(response.data.one.groups){
 this.groups.all = response.data.one.groups
 this.groups.catList = response.data.one.catList
 this.groups.selectedCat = response.data.one.selectedCat
} else this.groups.all = []
 this.active
 this.groups.beforeDisplayed = this.groups.active
 this.groups.removeList.loading = false
 this.groups.modals.removeCatSelected = false
})
},



   changeCat(){

     if(this.groups.selected.length>0){
     this.groups.modals.changeCatSelected = true
   } else {
     this.sb.color = 'error'
     this.sb.text = 'Выберите хотя бы 1 сообщество'
     this.sb.snackbar = true
   }
   },
   changeCatList(){

     this.lists.loading = true
     axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/change_list.php',{
       method: 'POST',
       data: {
         type: 'transfer',
         newListName: this.lists.newListName,
         grIds: this.groups.selected
       }
     })
     .then( response => {

       this.groups.catList.push(this.lists.newListName)
       this.groups.selectedCat = this.lists.newListName

       axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_get_by_list.php', {
          method: 'POST',
          data : {catList:this.groups.catList, selectedCat:this.groups.selectedCat,sort:this.groups.sort.selected },
          }).then(response => {
      this.groups.loading = false
      if(response.data.one.groups){
      this.groups.all = response.data.one.groups
      this.groups.catList = response.data.one.catList
      this.groups.selectedCat = response.data.one.selectedCat
     } else this.groups.all = []
      this.active
      this.groups.beforeDisplayed = this.groups.active

      this.lists.loading = false
      this.groups.modals.changeCatSelected = false
      this.lists.createNew = false
      this.lists.newListName = ""
          })


     })

   },
   update: function(){

     if(this.groups.selected.length>0){


     this.groups.checker.foundData.selector = false
     this.groups.checker.foundData.foundIds = []
     this.groups.checker.foundData.displayIds = []
     this.groups.checker.foundData.selectedIds = []
     this.groups.checker.foundData.offset = 0
     this.groups.checkList = []

   this.groups.selected.forEach( (item, i, arr)=>{
     this.groups.checkList.push(item.id)
   })
     this.groups.selected = []
     this.groups.beforeDisplayed.forEach(function(item, i, arr){
       item.add_info.selected = false
     })

     this.groups.modals.checkGroup = true
   } else {
     this.sb.color = 'error'
     this.sb.text = 'Выберите хотя бы 1 сообщество'
     this.sb.snackbar = true
   }
   },
   deleteSelected(){
     if(this.groups.selected.length>0){
     this.groups.modals.deleteSelected = true
   } else {
     this.sb.color = 'error'
     this.sb.text = 'Выберите хотя бы 1 сообщество'
     this.sb.snackbar = true
   }
   },
   selectAll: function(){

     if(this.groups.selector ===  true){

       this.groups.selected = []
       this.groups.selector = false
       this.groups.beforeDisplayed.forEach(function(item, i, arr){
         item.add_info.selected = false
       })



     }
     else {
       this.groups.beforeDisplayed.forEach(function(item, i, arr){
         item.add_info.selected = true
       })
       this.groups.selected = []
       this.groups.selected =  this.groups.selected.concat(this.groups.beforeDisplayed)
       this.groups.selector = true
     }

   },
copy(){
if(this.groups.selected.length>0){
console.log(this.groups.selected)
let data = []



this.groups.selected.forEach(function(item, i, arr){
data.push(item.id_of_group)
    })


     const url = window.URL.createObjectURL(new Blob([data.join(',')]));
     const link = document.createElement('a');
     link.href = url;
     link.setAttribute('download', 'groups.txt');
     document.body.appendChild(link);
     link.click()

     navigator.clipboard.writeText(data.join(','))

     .then ( ()=>{
       this.sb.color = 'success'
       this.sb.text = 'Скопированно '+this.groups.selected.length
       this.sb.snackbar = true
     }
      )
} else {
  this.sb.color = 'error'
  this.sb.text = 'Выберите хотя бы 1 сообщество'
  this.sb.snackbar = true
}

},

toExports: function(){

  if(this.groups.selected.length>0){
   this.toExport.dialog = true
   this.toExport.loading = true
   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
        method: 'POST',
        data: {
          contentType: 'groups'
        }
      })
      .then( response => {
        this.toExport.loading = false
        this.toExport.tasksList = response.data

      })
} else {
this.sb.color = 'error'
this.sb.text = 'Выберите хотя бы один элемент'
this.sb.snackbar = true
}
},
exportResources: function(){

     this.toExport.adding = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/add_resourcess.php', {
       method: 'POST',
       data: {
       taskIds: this.tasks.selected,
       data: this.groups.selected
       }
     })
     .then( response => {
       console.log(response.data)
       this.toExport.adding = false
       this.toExport.dialog = false
       this.tasks.selected = []
       this.sb.color = 'success'
       this.sb.text = 'Успешный экспорт '+this.groups.selected.length
       this.sb.snackbar = true

     })
}



},
computed: {

}
 }
</script>



<style scoped>
#meneger_wrapper{

  width: 250px;
  background-color: white;
  border-radius: 2px;
  box-shadow: 0 2px 0 0 #d7d8db, 0 0 0 2px #e3e4e8;
  margin-left: 10px
}
#meneg_block {
position: relative;
background: #fff;
border-radius: 2px;
-webkit-box-shadow: 0 1px 0 0 #d7d8db, 0 0 0 1px #e3e4e8;
box-shadow: 0 1px 0 0 #d7d8db, 0 0 0 1px #e3e4e8;
margin: 15px 0 0;
}
.meneg_item2{
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 32px;
    line-height: 31px;
    padding: 0 5px 0 20px;
    color: #2a5885;
    -ms-user-select: none;
    user-select: none;
    -o-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    outline: none;
    cursor: pointer;
border-left: 3px solid #5181B8;
background-color: #F0F2F5;
}


</style>
